import { isEqual } from 'lodash';
import React, { FC, useState } from 'react';
import { ActionMeta } from 'react-select';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { MultiValue, Option } from 'components/atoms/select/types';
import { BaseSelect } from 'components/organisms/task-pane/task-detail/task-fields/task-custom-fields/fields/base-select';
import { MultiSelectField as MultiSelectFieldT } from 'components/organisms/tasks/fields';
import { FieldHelper } from 'utils/field';

interface FieldProps {
  field: MultiSelectFieldT;
  disabled?: boolean;
  onChange?: (selected: number[] | null, field: MultiSelectFieldT) => void;
}

export const MultiSelectField: FC<FieldProps> = ({
  field,
  disabled = false,
  onChange,
}) => {
  const { value = [] } = field;
  const {
    options: { activeOptions, allOptions },
  } = FieldHelper(field);
  const [state, setState] = useState<MultiValue>([]);

  /* TODO:: can be moved to common hook(useMultiSelectState) just like useInput. so that, multi-user select also can share the code */
  useDeepCompareEffect(() => {
    const selected = allOptions.filter((x) => value.includes(x.value));

    setState(selected);
  }, [allOptions, value]);

  const commit = (latest: MultiValue | null) => {
    if (onChange && !isEqual(state, value)) {
      onChange(latest?.map((s) => Number(s.value)) || null, field);
    }
  };

  const handleChange = (latest: MultiValue, { action }: ActionMeta<Option>) => {
    setState(latest);

    if (action === 'remove-value' || action === 'clear') {
      commit(latest);
    }
  };

  return (
    <BaseSelect
      isMulti
      disabled={disabled}
      closeMenuOnSelect={false}
      value={state}
      options={activeOptions}
      onChange={handleChange}
      onMenuClose={() => commit(state)}
      styles={{
        valueContainer: (base) => ({
          ...base,
          maxHeight: '40px',
          overflow: 'auto',
        }),
      }}
    />
  );
};
